"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skipQuestion = exports.setViewQuestion = exports.setSkippedQuestionIds = exports.setQuestions = exports.setQuestionIndexInFlow = exports.setMetadata = exports.setIsExclusiveSelection = exports.setHandsetSearchList = exports.setFlags = exports.setBudget = exports.resetSelections = exports.resetQuestionnaireOnError = exports.resetQuestionnaireOnConfirmMessage = exports.resetQuestionnaire = exports.resetBudgetAndRecommendation = exports.replaceSelection = exports.removeSelection = exports.gotoQuestion = exports.gotoPreviousQuestion = exports.gotoNextQuestion = exports.fetchBudget = exports.endSummary = exports.endQuestionnaire = exports.adjustBudget = exports.addSelection = exports.VIEW_QUESTION = exports.SKIP_QUESTION = exports.SET_SKIPPED_QUESTION_IDS = exports.SET_QUESTION_INDEX_IN_FLOW = exports.SET_QUESTIONS = exports.SET_METADATA = exports.SET_IS_EXCLUSIVE_SELECTION = exports.SET_HANDSET_SEARCH_LIST = exports.SET_FLAGS = exports.SET_BUDGET = exports.RESET_SELECTIONS = exports.RESET_QUESTIONNAIRE_ON_ERROR = exports.RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE = exports.RESET_QUESTIONNAIRE = exports.RESET_BUDGET_AND_RECOMMENDATION = exports.REPLACE_SELECTION = exports.REMOVE_SELECTION = exports.PROGRESS_BAR_PERCENTAGE = exports.GOTO_QUESTION = exports.GOTO_PREVIOUS_QUESTION = exports.GOTO_NEXT_QUESTION = exports.FETCH_BUDGET_SUCCESS = exports.FETCH_BUDGET = exports.END_SUMMARY = exports.END_QUESTIONNAIRE = exports.ADJUST_BUDGET = exports.ADD_SELECTION = void 0;
const SET_QUESTIONS = 'SET_QUESTIONS';
exports.SET_QUESTIONS = SET_QUESTIONS;
const GOTO_NEXT_QUESTION = 'GOTO_NEXT_QUESTION';
exports.GOTO_NEXT_QUESTION = GOTO_NEXT_QUESTION;
const GOTO_PREVIOUS_QUESTION = 'GOTO_PREVIOUS_QUESTION';
exports.GOTO_PREVIOUS_QUESTION = GOTO_PREVIOUS_QUESTION;
const SKIP_QUESTION = 'SKIP_QUESTION';
exports.SKIP_QUESTION = SKIP_QUESTION;
const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE';
exports.RESET_QUESTIONNAIRE = RESET_QUESTIONNAIRE;
const END_QUESTIONNAIRE = 'END_QUESTIONNAIRE';
exports.END_QUESTIONNAIRE = END_QUESTIONNAIRE;
const ADD_SELECTION = 'ADD_SELECTION';
exports.ADD_SELECTION = ADD_SELECTION;
const REMOVE_SELECTION = 'REMOVE_SELECTION';
exports.REMOVE_SELECTION = REMOVE_SELECTION;
const REPLACE_SELECTION = 'REPLACE_SELECTION';
exports.REPLACE_SELECTION = REPLACE_SELECTION;
const RESET_SELECTIONS = 'RESET_SELECTIONS';
exports.RESET_SELECTIONS = RESET_SELECTIONS;
const SET_HANDSET_SEARCH_LIST = 'SET_HANDSET_SEARCH_LIST';
exports.SET_HANDSET_SEARCH_LIST = SET_HANDSET_SEARCH_LIST;
const FETCH_BUDGET = 'FETCH_BUDGET';
exports.FETCH_BUDGET = FETCH_BUDGET;
const SET_BUDGET = 'SET_BUDGET';
exports.SET_BUDGET = SET_BUDGET;
const RESET_BUDGET_AND_RECOMMENDATION = 'RESET_BUDGET_AND_RECOMMENDATION';
exports.RESET_BUDGET_AND_RECOMMENDATION = RESET_BUDGET_AND_RECOMMENDATION;
const ADJUST_BUDGET = 'ADJUST_BUDGET';
exports.ADJUST_BUDGET = ADJUST_BUDGET;
const FETCH_BUDGET_SUCCESS = 'FETCH_BUDGET_SUCCESS';
exports.FETCH_BUDGET_SUCCESS = FETCH_BUDGET_SUCCESS;
const END_SUMMARY = 'END_SUMMARY';
exports.END_SUMMARY = END_SUMMARY;
const GOTO_QUESTION = 'GOTO_QUESTION';
exports.GOTO_QUESTION = GOTO_QUESTION;
const VIEW_QUESTION = 'VIEW_QUESTION';
exports.VIEW_QUESTION = VIEW_QUESTION;
const PROGRESS_BAR_PERCENTAGE = 'PROGRESS_BAR_PERCENTAGE';
exports.PROGRESS_BAR_PERCENTAGE = PROGRESS_BAR_PERCENTAGE;
const RESET_QUESTIONNAIRE_ON_ERROR = 'RESET_QUESTIONNAIRE_ON_ERROR';
exports.RESET_QUESTIONNAIRE_ON_ERROR = RESET_QUESTIONNAIRE_ON_ERROR;
const RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE = 'RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE';
exports.RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE = RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE;
const SET_QUESTION_INDEX_IN_FLOW = 'SET_QUESTION_INDEX_IN_FLOW';
exports.SET_QUESTION_INDEX_IN_FLOW = SET_QUESTION_INDEX_IN_FLOW;
const SET_IS_EXCLUSIVE_SELECTION = 'SET_IS_EXCLUSIVE_SELECTION';
exports.SET_IS_EXCLUSIVE_SELECTION = SET_IS_EXCLUSIVE_SELECTION;
const SET_METADATA = 'SET_METADATA';
exports.SET_METADATA = SET_METADATA;
const SET_FLAGS = 'SET_FLAGS';
exports.SET_FLAGS = SET_FLAGS;
const SET_SKIPPED_QUESTION_IDS = 'SET_SKIPPED_QUESTION_IDS';
exports.SET_SKIPPED_QUESTION_IDS = SET_SKIPPED_QUESTION_IDS;
const setQuestions = questions => ({
  type: SET_QUESTIONS,
  payload: {
    questions
  }
});
exports.setQuestions = setQuestions;
const gotoNextQuestion = _ref => {
  let {
    nextQuestionIndex,
    metadata,
    summary,
    id
  } = _ref;
  return {
    type: GOTO_NEXT_QUESTION,
    payload: {
      nextQuestionIndex,
      metadata,
      summary,
      id
    }
  };
};
exports.gotoNextQuestion = gotoNextQuestion;
const gotoPreviousQuestion = () => ({
  type: GOTO_PREVIOUS_QUESTION
});
exports.gotoPreviousQuestion = gotoPreviousQuestion;
const gotoQuestion = id => ({
  type: GOTO_QUESTION,
  payload: {
    id
  }
});
exports.gotoQuestion = gotoQuestion;
const skipQuestion = nextQuestionIndex => ({
  type: SKIP_QUESTION,
  payload: {
    nextQuestionIndex
  }
});
exports.skipQuestion = skipQuestion;
const setViewQuestion = questionIndex => ({
  type: VIEW_QUESTION,
  payload: {
    viewQuestionIndex: questionIndex
  }
});
exports.setViewQuestion = setViewQuestion;
const resetQuestionnaire = () => ({
  type: RESET_QUESTIONNAIRE
});
exports.resetQuestionnaire = resetQuestionnaire;
const resetQuestionnaireOnError = () => ({
  type: RESET_QUESTIONNAIRE_ON_ERROR
});
exports.resetQuestionnaireOnError = resetQuestionnaireOnError;
const resetQuestionnaireOnConfirmMessage = () => ({
  type: RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE
});
exports.resetQuestionnaireOnConfirmMessage = resetQuestionnaireOnConfirmMessage;
const endQuestionnaire = () => ({
  type: END_QUESTIONNAIRE
});
exports.endQuestionnaire = endQuestionnaire;
const addSelection = selection => ({
  type: ADD_SELECTION,
  payload: {
    selection
  }
});
exports.addSelection = addSelection;
const removeSelection = selection => ({
  type: REMOVE_SELECTION,
  payload: {
    selection
  }
});
exports.removeSelection = removeSelection;
const replaceSelection = function (selection) {
  let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    type: REPLACE_SELECTION,
    payload: {
      selection,
      index
    }
  };
};
exports.replaceSelection = replaceSelection;
const resetSelections = () => ({
  type: RESET_SELECTIONS
});
exports.resetSelections = resetSelections;
const setHandsetSearchList = handsetList => ({
  type: SET_HANDSET_SEARCH_LIST,
  payload: {
    handsetList
  }
});
exports.setHandsetSearchList = setHandsetSearchList;
const fetchBudget = () => ({
  type: FETCH_BUDGET
});
exports.fetchBudget = fetchBudget;
const setBudget = budget => ({
  type: SET_BUDGET,
  payload: {
    budget
  }
});
exports.setBudget = setBudget;
const resetBudgetAndRecommendation = () => ({
  type: RESET_BUDGET_AND_RECOMMENDATION
});
exports.resetBudgetAndRecommendation = resetBudgetAndRecommendation;
const adjustBudget = budgetAdjusted => ({
  type: ADJUST_BUDGET,
  payload: {
    budgetAdjusted
  }
});
exports.adjustBudget = adjustBudget;
const endSummary = () => ({
  type: END_SUMMARY
});
exports.endSummary = endSummary;
const setQuestionIndexInFlow = payload => ({
  type: SET_QUESTION_INDEX_IN_FLOW,
  payload
});
exports.setQuestionIndexInFlow = setQuestionIndexInFlow;
const setIsExclusiveSelection = payload => {
  return {
    type: SET_IS_EXCLUSIVE_SELECTION,
    payload
  };
};
exports.setIsExclusiveSelection = setIsExclusiveSelection;
const setMetadata = metadata => ({
  type: SET_METADATA,
  payload: {
    metadata
  }
});
exports.setMetadata = setMetadata;
const setFlags = flags => ({
  type: SET_FLAGS,
  payload: {
    flags
  }
});
exports.setFlags = setFlags;
const setSkippedQuestionIds = skippedQuestionIds => ({
  type: SET_SKIPPED_QUESTION_IDS,
  payload: {
    skippedQuestionIds
  }
});
exports.setSkippedQuestionIds = setSkippedQuestionIds;